var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _g2, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 340,
    height: 218,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3B58E3",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M129.563 80.047v41.562M149.477 99.997H109.65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B58E3",
    d: "M129.563 106.646c3.666 0 6.638-2.977 6.638-6.65 0-3.672-2.972-6.65-6.638-6.65s-6.638 2.978-6.638 6.65 2.972 6.65 6.638 6.65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#star_svg__a)",
    d: "M8.428 171.682 230.91 68.891l34.797 40.756-21.933 48.178-238.45 22.929z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3B58E3",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M35.825 50.242v32.195M51.25 65.696H20.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B58E3",
    d: "M35.825 70.847a5.147 5.147 0 0 0 5.142-5.151 5.146 5.146 0 0 0-5.142-5.151 5.146 5.146 0 0 0-5.142 5.15 5.147 5.147 0 0 0 5.142 5.152"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3B58E3",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M71.4 162.648v42.579M91.8 183.086H51"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B58E3",
    d: "M71.4 189.898c3.756 0 6.8-3.05 6.8-6.812s-3.044-6.813-6.8-6.813-6.8 3.05-6.8 6.813 3.045 6.812 6.8 6.812"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "star_svg__b",
    width: 131,
    height: 150,
    x: 186,
    y: 34,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F1C22",
    d: "M316.356 124.726c3.531 40.424-21.151 58.811-56.343 58.811-35.191 0-69.332-32.073-72.862-72.497s23.52-76.191 58.711-76.191c36.288-2.653 66.964 49.452 70.494 89.877"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#star_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1F1C22",
    d: "M315.071 124.726c3.53 40.424-21.152 58.811-56.343 58.811s-69.333-32.073-72.863-72.497 23.52-76.191 58.712-76.191c36.288-2.653 66.963 49.452 70.494 89.877"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M235.276 58.69h-49.74v10.713h49.74zM228.944 94.177h-49.741v46.306h49.741zM269.381 166.2h-63.015v7.04h63.015z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "star_svg__c",
    width: 131,
    height: 148,
    x: 199,
    y: 34,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B58E3",
    stroke: "#2CB54E",
    d: "M258.337 34.56c35.324 0 66.937 32.738 70.483 73.269 3.546 40.53-22.339 73.267-57.663 73.267-35.324-.001-66.936-32.737-70.482-73.267-3.546-40.531 22.338-73.268 57.662-73.268Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#2CB54E",
    mask: "url(#star_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2CB54E",
    strokeWidth: 2,
    d: "M258.368 34.91c35.089 0 66.563 32.536 70.09 72.919 3.526 40.383-22.266 72.918-57.355 72.918s-66.563-32.535-70.09-72.918 22.266-72.918 57.355-72.918Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M267.859 43.514c35.089 0 66.563 32.535 70.09 72.918s-22.266 72.919-57.355 72.919-66.563-32.536-70.09-72.919c-3.526-40.383 22.266-72.918 57.355-72.918Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M243.86 68.714h16.254l1.973 18.801h-16.15c-7.234 0-13.201 3.753-16.254 9.409-1.694-2.672-2.823-5.733-3.162-8.961-1.116-10.64 6.639-19.25 17.339-19.25ZM229.844 98.948c4.201 5.636 10.927 9.399 18.174 9.399h16.254l1.973 18.801h-16.15c-10.741 0-20.374-8.673-21.494-19.354-.335-3.194.142-6.192 1.243-8.846ZM299.787 118.734c1.695 2.672 2.825 5.733 3.163 8.962 1.117 10.64-6.639 19.249-17.339 19.249h-16.254l-1.973-18.801h16.149c7.236 0 13.202-3.754 16.254-9.41ZM279.379 88.544c10.741 0 20.374 8.673 21.495 19.353.335 3.195-.143 6.192-1.244 8.847-4.201-5.636-10.927-9.398-18.174-9.398h-16.254l-1.973-18.802z"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B58E3",
    d: "M27.625 131.141a2.98 2.98 0 0 0 2.975-2.981 2.977 2.977 0 0 0-2.975-2.98 2.977 2.977 0 0 0-2.975 2.98 2.98 2.98 0 0 0 2.975 2.981M65.45 108.148a4.254 4.254 0 0 0 4.25-4.257 4.254 4.254 0 0 0-4.25-4.258 4.254 4.254 0 0 0-4.25 4.258 4.253 4.253 0 0 0 4.25 4.257M145.35 194.156a2.553 2.553 0 0 0 2.55-2.554 2.553 2.553 0 0 0-2.55-2.555 2.553 2.553 0 0 0-2.55 2.555 2.553 2.553 0 0 0 2.55 2.554"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "star_svg__a",
    x1: 8.169,
    x2: 204.703,
    y1: 172.255,
    y2: 38.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#BECBFD"
  })))));
};
export default SvgStar;